import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { useQueryState, parseAsString } from 'nuqs'
import useQueryGetTournaments from '@/modules/tournament/api/hooks/useQueryGetTournaments'
import TournamentListing from '@/modules/tournament/components/TournamentListing'
import type { paths } from '@/schema'

type TournamentStatus =
	paths['/api/admin/tournaments']['get']['parameters']['query']['status']

function TournamentsPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()

	const [status] = useQueryState(
		'status',
		parseAsString.withOptions({ shallow: false }).withDefault(''),
	)
	const [isActive] = useQueryState(
		'isActive',
		parseAsString.withOptions({ shallow: false }).withDefault(''),
	)

	const query = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		search: searchQuery || undefined,
		status: (status as TournamentStatus) || undefined,
		isActive: isActive ? isActive === 'true' : undefined,
	}

	const { data, isLoading } = useQueryGetTournaments(query)

	return (
		<PageContainer>
			<TournamentListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

export default withUserPermission(TournamentsPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_GAME],
})
